import React from "react";
import {
  Table,
  Page,
  Breadcrumb,
  BreadcrumbData,
} from "@avlino-inc/alenza-react";
import styles from "./About.module.scss";
import { Card } from "react-bootstrap";
import { useHistory } from "react-router";
import MainNav from "components/nav/MainNav";
import { getJwtReducerResponse } from "store/selectors";
import { useSelector } from "react-redux";
import { JWT, AboutMicroservice } from "types";
import * as routes from "routes";

type AboutProps = {
  microservices: AboutMicroservice[];
};

type Component = React.FC<AboutProps>;

const breadcrumbItems: BreadcrumbData[] = [
  { label: "Command Center", url: routes.HOME },
  { label: "About", url: routes.ABOUT },
];

const AboutPageView: Component = function (props) {
  const history = useHistory();

  const jwtPayloadData: JWT = useSelector((state) =>
    getJwtReducerResponse(state, "data")
  );

  return (
    <div id="AboutPage">
      <MainNav
        first_name={jwtPayloadData && jwtPayloadData.first_name}
        last_name={jwtPayloadData && jwtPayloadData.last_name}
        username={jwtPayloadData && jwtPayloadData.username}
        email={jwtPayloadData && jwtPayloadData.email}
      />
      <div style={{ display: "flex" }}>
        <main id="page-wrap">
          <Page>
            <Page.Header>
              <Breadcrumb items={breadcrumbItems} onClickItem={history.push} />
            </Page.Header>
            <Card className={styles["about__container"]}>
              <Table>
                <thead>
                  <th>Service</th>
                  <th>Version</th>
                  <th>Release Date</th>
                  <th>Status</th>
                </thead>
                <tbody>
                  {props.microservices.map((item) => (
                    <tr key={item.name}>
                      <td>{item.name}</td>
                      <td>{item.version}</td>
                      <td>{item.release_date_str}</td>
                      <td>{item.is_running ? "ON" : "OFF"}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </Card>
          </Page>
        </main>
      </div>
    </div>
  );
};

export default AboutPageView;
